// helpers/membershipFeatures.js
export const getBandFeatures = (membershipLevel) => {
    const isPremium = membershipLevel === "premium";
  
    return {
      canEditGenres: isPremium ? 4 : 1,
      canUseGallery: isPremium,
      maxGalleryImages: isPremium ? 6 : 0,
      canUseVideoLink: isPremium,
      showVideo: isPremium,
      canUseAudioPlayer: isPremium,
      canUseSocialLinks: isPremium,
      canUseStarRating: isPremium,
      canUseOwnServices: isPremium,
      canBeFeatured: isPremium,
      soundcloudLinks: isPremium ? 4 : 1,
      canUseMainImage: true,
      canEditDescription: true,
      canUseCalendar: true,
      canUseCustomerMessaging: true,
    };
  };
  